module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-25.a7130218.svg";